import featuredProjects from "./featured-projects.js";

const INFO = {
	main: {
		title: "Swapnil Tamse, AI Engineering Leader",
		name: "Swapnil Tamse",
		email: "hi@swapniltamse.com",
		logo: "../logo.png",
	},

	socials: {
		twitter: "https://twitter.com/tamseji",
		github: "https://github.com/swapniltamse",
		linkedin: "https://linkedin.com/in/swapniltamse",
		instagram: "https://instagram.com/swapniltamse",
		facebook: "https://facebook.com/swapniltamse",
	},

	homepage: {
		title: "I ship AI.\nI grow engineers.",
		description:
			"I develop AI applications that make it to production, and I lead the engineering teams that keep them running. Not demos. Real software people use.\n" +
			"My other half is governance. In regulated finance an AI app only ships if you can measure it, explain it, and stand behind it.\n" +
			"I like hard problems, and I like helping other engineers grow.",
	},

	about: {
		title: "I build engineering teams that ship without me.",
		lead:
			"I lead by growing the people who do the work. I keep enough technical depth to make the hard calls and earn trust, but my job is to multiply through the team, not to be the bottleneck.",
		description:
			"My depth is AI in regulated finance. More than ten of my fifteen years have been in financial services, where being wrong is expensive and accountability is not optional. The rest spans logistics, ed-tech, ad-tech, and web. Different industries, same hard problems, so I adapt fast and rarely get surprised.\n\n" +
			"I have delivered under waterfall and the many flavors of agile, so I know what moves work forward and what is just theatre. Whether the team is three engineers or thirty, the job is the same. Hire well, tie the work to outcomes that matter, put the right people on the right problems, and get out of their way.\n\n" +
			"I judge myself by one test. Is the team stronger for having worked with me, and does it deliver when I am not in the room?",
	},

	articles: {
		title: "Writing",
		description:
			"Long-form pieces on AI systems, governance, and engineering leadership. The things I could not fit into a LinkedIn post, several of them with a working tool built in.",
	},

	projects: featuredProjects,
};

export default INFO;
